import React from "react";
import Header from "../../header";
import { apiCall_domain, token } from "../../api";
import axios from "axios";
import PulseLoader from "react-spinners/PulseLoader";

class EnterPass extends React.Component {
  state = {
    changeDetail: true,
    Password: "",
    error: "",
    loading: false,
  };
  componentDidMount() {
    if (localStorage.getItem("Api_key")) {
      this.props.history.push("/");
      window.close();
    }
  }
  render() {
    const SetPassword = (e) => {
      this.setState({
        Password: e.target.value,
      });
    };
    const handleSubmit = (e) => {
      e.preventDefault();
      this.setState({ loading: true });
      const Headers = {
        Authorization: token(),
        "content-type": "application/json",
      };
      const Data = {
        phone: localStorage.getItem("phone"),
        password: this.state.Password,
        dev_type: "IOS",
        gcm_id: "1",
      };
      axios
        .post(`${apiCall_domain}/customer/auth/login`, Data, {
          headers: Headers,
        })

        .then((res) => {
          localStorage.setItem("Api_key", res.data.api_key);
          localStorage.removeItem("phone");
          localStorage.removeItem("validationCode");
          this.setState({ loading: true });
          const url = new URL(window.location.href);
          window.location.replace(url.origin);
        })
        .then((res) => {
          axios
            .get(`${apiCall_domain}/cusomer/splash`, { headers: Headers })
            .then((res) => {
              localStorage.setItem("splash", JSON.stringify(res.data));
            });
        })
        .catch((error) => {
          this.setState({ loading: false, error: error.response.data.errors });
        });
    };
    const recPass = () => {
      localStorage.setItem("successValid", "");
      this.setState({ loading: true });
      const Headers = {
        Authorization: token(),
        "content-type": "application/json",
      };
      const Data2 = {
        phone: localStorage.getItem("phone"),
      };
      axios
        .post(`${apiCall_domain}/customer/auth/forget_password/s1`, Data2, {
          headers: Headers,
        })
        .then((res) => {
          this.props.history.push({
            pathname: "/EnterPass/forgetPassStep1",
            phone: this.props.location.state,
          });
        });
    };

    return (
      <>
        <div className="EnterPass">
          <Header showSearchBar={true} title={"ورود به حساب کاربری"} />
          <div className="phoneBox">
            <div className="phoneTitle">رمز عبور خود را وارد کنید</div>
            <input
              className="input"
              placeholder="********"
              type={"password"}
              onChange={(e) => SetPassword(e)}
            ></input>
            <div className="forgetPassBox">
              <span className="forget">رمز عبور خود را فراموش کرده اید؟</span>
              <span className="passRecovery" onClick={() => recPass()}>
                بازیابی رمز عبور
              </span>
            </div>
            <div className="error">{this.state.error}</div>
          </div>
          <img
            src="/public/assets/img/login/login.svg"
            alt="carousel"
            className="loginPic"
          />

          <div className="mySecContinueEnter">
            {this.state.loading ? (
              <button className="btn disabled">
                <PulseLoader size={12} color="#fff" loading={true} />
              </button>
            ) : (
              <button onClick={(e) => handleSubmit(e)}>ورود</button>
            )}
          </div>
        </div>
      </>
    );
  }
}
export default EnterPass;
